import { apiRequest } from "../api.jsx";

export const sendLoginOtp = (phone) =>
  apiRequest("/login/send-otp", "POST", { phone });

export const verifyLoginOtp = ({
  phone,
  otp,
  name,
  email,
  sponsorId,
  isRegistration = false,
  registerFrom = "web",
}) => apiRequest("/login/verify-otp", "POST", {
  phone,
  otp,
  name,
  email,
  sponsorId,
  isRegistration,
  registerFrom,
});
